'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Parse date into Date object.
// E.g. 1998-01-02 => Date(1998-01-02)
//  or  2.1.1998 => Date(1998-01-02)
_module3.default.filter('parsedate', function () {
    return function (date) {
        if (typeof date == 'string') {
            return (0, _utils.parseDate)(date);
        } else {
            return date;
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./src/core/parsedate.js
// module id = 48
// module chunks = 0 2